import classNames from 'classnames/bind';
import ApiResponseExample from '../../../GeneralComponents/ApiResponseExample';
import withComponentName from '../../../../decorators/withComponentName';
import { ApiResponseExampleData } from '../../../../data/apiResponseExampleData';

import pic from '../../../../assets/brokers/pic-api-6-screen.svg';
import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const BrokersLiveSection = () => (
  <section className={cx('structured-data-section')}>
    <div className={Styles['section-wrapper']}>
      <div className={Styles['section-head']}>
        <h2 className={Styles['section-title']}>Go Live Within Hours</h2>
        <p className={Styles.description}>
          Easy integration with our API
        </p>
      </div>
      <div className={Styles['structed-data-main']}>
        <ApiResponseExample
          codeExample={ApiResponseExampleData}
        />
        <div>
          <img src={pic} alt="cityfalcon structured data" />
        </div>
      </div>
    </div>
  </section>
);

export default withComponentName(BrokersLiveSection);
